function getCoupons() {
	jQuery( ".results_entry" ).each(function(  ) {
	  var store_name = jQuery(this).find('.store-name').html();
	  for(i=0; i<coupons.length; i++) {
	  	if(store_name == coupons[i].store_name) {
	  		jQuery(this).append('<div class="coupon"><a href="'+coupons[i].coupon_link+'" target="_blank">'+coupons[i].coupon_text+'</a></div>');
	  	}
	  }
	});
}